import React, { useEffect, useState } from "react";
import AuthService from "../../../api/services/AuthService";
import LoaderHelper from "../../../customComponent/Loading/LoaderHelper";
import { alertSuccessMessage, alertErrorMessage } from "../../../customComponent/CustomAlertMessage";

const AdminFiatBankList = () => {
  const [bankList, setBankList] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [showAddModal, setShowAddModal] = useState(false);
  const [currencyList, setCurrencyList] = useState([]);
  const [newBankData, setNewBankData] = useState({
    currency: "",
    account_holder_name: "",
    account_number: "",
    bank_name: "",
    country: "",
    ifsc_code: "",
    swift_code: "",
    iban: "",
    notes: "",
    is_active: true
  });

  const fetchData = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const res = await AuthService.getFiatAccounts();
      if (res.success) {
        setBankList(res.data);
      } else {
        alertErrorMessage("Failed to fetch bank accounts");
      }
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const fetchCurrencyList = async () => {
    try {
      const res = await AuthService.fiatCurrencyList();
      if (res.success) {
        return res.data?.fiatCurrencies || [];
      } else {
        alertErrorMessage("Failed to fetch currency list");
        return [];
      }
    } catch (e) {
      alertErrorMessage("Error fetching currency list");
      return [];
    }
  };

  useEffect(() => {
    fetchData();
    fetchCurrencyList().then(setCurrencyList);
  }, []);

  const handleEditClick = (item) => {
    setEditData({ ...item });
    setShowEditModal(true);
  };

  const handleChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditModalClose = () => {
    setShowEditModal(false);
    setEditData({});
  };

  const handleSave = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const res = await AuthService.updateFiatAccounts(editData);
      if (res.success) {
        alertSuccessMessage("Bank account updated");
        handleEditModalClose();
        fetchData();
      } else {
        alertErrorMessage(res.message);
      }
    } catch (e) {
      alertErrorMessage("Error updating bank");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleRemove = async (item) => {
    if (!window.confirm(`Are you sure you want to delete the bank account for ${item.account_holder_name}?`)) {
      return;
    }
    LoaderHelper.loaderStatus(true);
    try {
      const res = await AuthService.deleteFiatAccount(item._id);
      if (res.success) {
        alertSuccessMessage("Bank account deleted successfully");
        fetchData();
      } else {
        alertErrorMessage(res.message || "Failed to delete bank account");
      }
    } catch (e) {
      alertErrorMessage("Error deleting bank account");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleAddBank = () => {
    setShowAddModal(true);
  };

  const handleAddModalClose = () => {
    setShowAddModal(false);
    setNewBankData({
      currency: "",
      account_holder_name: "",
      account_number: "",
      bank_name: "",
      country: "",
      ifsc_code: "",
      swift_code: "",
      iban: "",
      notes: "",
      is_active: true
    });
  };

  const handleNewBankChange = (field, value) => {
    setNewBankData((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddBankSubmit = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      console.log("New Bank Data:", newBankData);
      const res = await AuthService.updateFiatAccounts(newBankData);
      if (res.success) {
        alertSuccessMessage("Bank account added successfully");
        handleAddModalClose();
        fetchData();
      } else {
        alertErrorMessage(res.message || "Failed to add bank account");
      }
    } catch (e) {
      alertErrorMessage("Error adding bank account");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <div id="layoutSidenav_content">
      <div className="card">
    <div className="container-xl px-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Fiat Bank Accounts</h2>
        <button className="btn btn-primary" onClick={handleAddBank}>
          <i className="fas fa-plus me-2"></i>Add Bank
        </button>
      </div>
      <div className="table-responsive mt-4">
        <table className="table custom-table">
          <thead>
            <tr>
              <th>Currency</th>
              <th>Account Holder</th>
              <th>Account Number</th>
              <th>Bank Name</th>
              <th>Country</th>
              <th>IFSC</th>
              <th>SWIFT</th>
              <th>IBAN</th>
              <th>Notes</th>
              <th>Active</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {bankList.map((item) => (
              <tr key={item._id}>
                <td>{item.currency}</td>
                <td>{item.account_holder_name}</td>
                <td>{item.account_number}</td>
                <td>{item.bank_name}</td>
                <td>{item.country}</td>
                <td>{item.ifsc_code}</td>
                <td>{item.swift_code}</td>
                <td>{item.iban}</td>
                <td>{item.notes}</td>
                <td>
                  <span className={item.is_active ? "text-success" : "text-danger"}>
                    {item.is_active ? "Yes" : "No"}
                  </span>
                </td>
                <td>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => handleEditClick(item)}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleRemove(item)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </div>

      {/* Edit Bank Modal */}
      {showEditModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content p-4">
              <div className="modal-header">
                <h5 className="modal-title">Edit Bank Account</h5>
                <button type="button" className="btn-close" onClick={handleEditModalClose}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Currency</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.currency || ""}
                      onChange={(e) => handleChange("currency", e.target.value)}
                      placeholder="Enter currency (e.g., USD, EUR)"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Account Holder Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.account_holder_name || ""}
                      onChange={(e) => handleChange("account_holder_name", e.target.value)}
                      placeholder="Enter account holder name"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Account Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.account_number || ""}
                      onChange={(e) => handleChange("account_number", e.target.value)}
                      placeholder="Enter account number"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Bank Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.bank_name || ""}
                      onChange={(e) => handleChange("bank_name", e.target.value)}
                      placeholder="Enter bank name"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Country</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.country || ""}
                      onChange={(e) => handleChange("country", e.target.value)}
                      placeholder="Enter country"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">IFSC Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.ifsc_code || ""}
                      onChange={(e) => handleChange("ifsc_code", e.target.value)}
                      placeholder="Enter IFSC code (optional)"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">SWIFT Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.swift_code || ""}
                      onChange={(e) => handleChange("swift_code", e.target.value)}
                      placeholder="Enter SWIFT code (optional)"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">IBAN</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData.iban || ""}
                      onChange={(e) => handleChange("iban", e.target.value)}
                      placeholder="Enter IBAN (optional)"
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Notes</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={editData.notes || ""}
                      onChange={(e) => handleChange("notes", e.target.value)}
                      placeholder="Enter any additional notes"
                    />
                  </div>
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={editData.is_active || false}
                        onChange={(e) => handleChange("is_active", e.target.checked)}
                        id="editIsActiveCheck"
                      />
                      <label className="form-check-label" htmlFor="editIsActiveCheck">
                        Active
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-0">
                <button type="button" className="btn btn-secondary" onClick={handleEditModalClose}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Update Bank Account
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Bank Modal */}
      {showAddModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content p-4">
              <div className="modal-header">
                <h5 className="modal-title">Add New Bank Account</h5>
                <button type="button" className="btn-close" onClick={handleAddModalClose}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Currency</label>
                    {/* <select
                      className="form-select"
                      value={newBankData.currency}
                      onChange={(e) => handleNewBankChange("currency", e.target.value)}
                    >
                      {currencyList.map((currency) => (
                        <option key={currency?.short_name} value={currency?.short_name}>
                          {currency?.currency_name}
                        </option>
                      ))}
                    </select> */}
                    <input
                      type="text"
                      className="form-control"
                      value={newBankData.currency}
                      onChange={(e) => handleNewBankChange("currency", e.target.value)}
                      placeholder="Enter currency (e.g., USD, EUR)"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Account Holder Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newBankData.account_holder_name}
                      onChange={(e) => handleNewBankChange("account_holder_name", e.target.value)}
                      placeholder="Enter account holder name"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Account Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newBankData.account_number}
                      onChange={(e) => handleNewBankChange("account_number", e.target.value)}
                      placeholder="Enter account number"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Bank Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newBankData.bank_name}
                      onChange={(e) => handleNewBankChange("bank_name", e.target.value)}
                      placeholder="Enter bank name"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Country</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newBankData.country}
                      onChange={(e) => handleNewBankChange("country", e.target.value)}
                      placeholder="Enter country"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">IFSC Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newBankData.ifsc_code}
                      onChange={(e) => handleNewBankChange("ifsc_code", e.target.value)}
                      placeholder="Enter IFSC code (optional)"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">SWIFT Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newBankData.swift_code}
                      onChange={(e) => handleNewBankChange("swift_code", e.target.value)}
                      placeholder="Enter SWIFT code (optional)"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">IBAN</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newBankData.iban}
                      onChange={(e) => handleNewBankChange("iban", e.target.value)}
                      placeholder="Enter IBAN (optional)"
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Notes</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={newBankData.notes}
                      onChange={(e) => handleNewBankChange("notes", e.target.value)}
                      placeholder="Enter any additional notes"
                    />
                  </div>
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={newBankData.is_active}
                        onChange={(e) => handleNewBankChange("is_active", e.target.checked)}
                        id="isActiveCheck"
                      />
                      <label className="form-check-label" htmlFor="isActiveCheck">
                        Active
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-0">
                <button type="button" className="btn btn-secondary" onClick={handleAddModalClose}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleAddBankSubmit}>
                  Add Bank Account
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminFiatBankList;
